(() => {
  const carouselSelector = '.jdgm-cards-carousel';
  const cardSelector = '.jdgm-media-card';

  const groupSizes = (count) => {
    const sizes = [];
    let remaining = count;

    while (remaining > 0) {
      if (remaining === 4) {
        sizes.push(2, 2);
        break;
      }

      const size = Math.min(3, remaining);
      sizes.push(size);
      remaining -= size;
    }

    return sizes;
  };

  const setActiveSlide = (slides, activeIndex) => {
    slides.forEach((slide, index) => {
      slide.classList.toggle('nm-review-slide-active', index === activeIndex);
      slide.querySelectorAll(cardSelector).forEach((card) => {
        card.classList.remove('active');
      });
      if (slide.matches(cardSelector)) slide.classList.toggle('active', index === activeIndex);
    });
  };

  const connectNavigation = (carousel, container) => {
    const wrapper = carousel.querySelector('.jdgm-cards-wrapper');
    const slides = Array.from(container.children).filter((element) => {
      return element.matches('.nm-text-review-stack, .jdgm-media-card');
    });

    if (!wrapper || slides.length === 0) return;

    carousel.nmReviewStackController?.abort();
    carousel.nmReviewStackController = new AbortController();
    const { signal } = carousel.nmReviewStackController;
    let activeIndex = 0;

    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      const maxOffset = Math.max(0, container.scrollWidth - wrapper.clientWidth);
      const offset = Math.min(slides[activeIndex].offsetLeft, maxOffset);
      container.style.transform = `translateX(${-offset}px)`;
      setActiveSlide(slides, activeIndex);
    };

    carousel.querySelectorAll('.jdgm-arrow').forEach((button) => {
      button.removeAttribute('onclick');
      button.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          const direction = button.getAttribute('aria-label')?.toLowerCase().includes('previous') ? -1 : 1;
          showSlide(activeIndex + direction);
        },
        { signal }
      );
    });

    window.addEventListener('resize', () => showSlide(activeIndex), { signal });
    showSlide(0);
  };

  const buildStacks = (carousel) => {
    const container = carousel.querySelector('.jdgm-videos-container');
    if (!container || container.dataset.nmReviewStacks === 'ready') return;

    const cards = Array.from(container.children).filter((element) => element.matches(cardSelector));
    if (cards.length === 0) return;

    let index = 0;

    while (index < cards.length) {
      if (!cards[index].classList.contains('jdgm-text-card')) {
        index += 1;
        continue;
      }

      const run = [];
      while (index < cards.length && cards[index].classList.contains('jdgm-text-card')) {
        run.push(cards[index]);
        index += 1;
      }

      let runIndex = 0;
      groupSizes(run.length).forEach((size) => {
        const stack = document.createElement('div');
        stack.className = 'nm-text-review-stack jdgm-carousel-item';
        stack.setAttribute('role', 'group');
        stack.setAttribute('aria-label', `${size} customer reviews`);
        run[runIndex].before(stack);

        for (let position = 0; position < size; position += 1) {
          stack.appendChild(run[runIndex + position]);
        }

        runIndex += size;
      });
    }

    container.dataset.nmReviewStacks = 'ready';
    carousel.classList.add('nm-review-stacks');
    connectNavigation(carousel, container);
  };

  const enhanceCarousels = () => {
    document.querySelectorAll(carouselSelector).forEach(buildStacks);
  };

  const observer = new MutationObserver(enhanceCarousels);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  enhanceCarousels();
})();
